import { IDynamicBaseStruct } from '../../../interfaces/IDynamicFields'

export namespace SmartResponseConstants {

  export const BASE_STRUCT: IDynamicBaseStruct = {
    boxes: {
      title: 'Boxes',
      fields: {
        title: {
          label: 'Title',
          type: 'text'
        },
        picture: {
          label: 'Picture',
          type: 'select'
        },
        labels: {
          label: 'Labels',
          type: 'object',
          fields: {
            label: {
              label: 'Label',
              type: 'text'
            },
            value: {
              label: 'Value',
              type: 'select'
            }
          }
        }
      }
    },
    cards: {
      title: 'Cards',
      fields: {
        label: {
          label: 'Label',
          type: 'text'
        },
        value: {
          label: 'Value',
          type: 'select'
        }
      }
    },
    main_buttons: {
      title: 'Main Buttons',
      fields: {
        text: {
          label: 'Text',
          type: 'text'
        },
        link: {
          label: 'Link',
          type: 'select'
        }
      }
    },
    final_buttons: {
      title: 'Final Buttons',
      fields: {
        text: {
          label: 'Text',
          type: 'text'
        },
        link: {
          label: 'Link',
          type: 'select'
        },
        primary: {
          label: 'Primary',
          type: 'boolean'
        }
      }
    }
  }


  export const COLLAPSED_FIELDS = [
    {
      key: 'boxes',
      title: 'Boxes'
    },
    {
      key: 'cards',
      title: 'Cards'
    },
    {
      key: 'main_buttons',
      title: 'Main Buttons'
    },
    {
      key: 'final_buttons',
      title: 'Final Buttons'
    }
  ] as const


  export const ICONS = [
    {
      path: 'enum/email_template/icon/adopets.png',
      name: 'Adopets',
      key: 'adopets.pn'
    },
    {
      path: 'enum/email_template/icon/check.png',
      name: 'Check',
      key: 'check.png'
    },
    {
      path: 'enum/email_template/icon/email.png',
      name: 'Email',
      key: 'email.png'
    },
    {
      path: 'enum/email_template/icon/key.png',
      name: 'Key',
      key: 'key.png'
    },
    {
      path: 'enum/email_template/icon/message.png',
      name: 'Message',
      key: 'message.png'
    },
    {
      path: 'enum/email_template/icon/money.png',
      name: 'Money',
      key: 'money.png'
    },
    {
      path: 'enum/email_template/icon/payment_received.png',
      name: 'Payment Received',
      key: 'payment_received.png'
    },
    {
      path: 'enum/email_template/icon/pet.png',
      name: 'Pet',
      key: 'pet.png'
    },
    {
      path: 'enum/email_template/icon/x.png',
      name: 'X',
      key: 'x.png'
    },
  ]
}